import * as React from "react";
import { useState, useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { Card, Row } from "react-bootstrap";
import { Loading } from "wup-module1-base";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleRight, faCircleLeft } from "@fortawesome/free-regular-svg-icons";

import { RoutePathConstants } from "../../Constants";
import UserContext from "../../Contexts/UserContext";
import { StoreService } from "../../Services";
import { WindowService, WindowText, WindowOffers } from "../../Components";
import "./Store.css";

function Store() {
  const { user, setUser } = useContext(UserContext);
  const navigate = useNavigate();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [isSubmittingButton, setIsSubmittingButton] = useState(false);

  const [itemsData, setItemsData] = useState();
  const [itemsDataOffer, setItemsDataOffer] = useState();
  const [itemsDataFunding, setItemsDataFunding] = useState();
  const [itemsDataService, setItemsDataService] = useState();
  const storedData = sessionStorage.getItem("storeData");
  const parsedData = JSON.parse(storedData);

  useEffect(() => {
    if (user.currentStep > 7) {
      navigate(`/${RoutePathConstants.StoreSummary}`);
    }

    if (isEditMode === true && itemsDataFunding && itemsDataOffer && offer) {
      let indexOfElement;
      itemsDataOffer.forEach((item, index) => {
        if (item.id === offer) {
          indexOfElement = index;
        }
        document.getElementById(`offer_picture_${index}`).className =
          "offer-1-gray";
        document.getElementById(`offer_${index}`).className = "offer-text-1";
      });

      let box = document.getElementById(`offer_${indexOfElement}`);
      let picture = document.getElementById(`offer_picture_${indexOfElement}`);
      box.className = "offer-text-1-selected";
      picture.className = "offer-1";
    }
  }, [isEditMode]);

  useEffect(() => {
    if (!itemsData) {
      setIsSubmitting(true);

      StoreService.storeItems()
        .then((response) => {
          setItemsData(response.data);
          
          setItemsDataFunding(response.data.filter((item) => item.type === 1));
          setItemsDataOffer(response.data.filter((item) => item.type === 2));
          setItemsDataService(response.data.filter((item) => item.type === 3));
          if (
            response.data.filter((item) => item.type === 1) &&
            response.data.filter((item) => item.type === 2)
          ) {
            setIsEditMode(true);
          }
        })
        .catch((error) => {
          console.error(error);
        })
        .finally(() => {
          setIsSubmitting(false);
        });
    }

    if (!!offer) {
      itemsDataOffer?.forEach((item, index2) => {
        document.getElementById(`offer_picture_${index2}`).className =
          "offer-1-gray";
        document.getElementById(`offer_${index2}`).className = "offer-text-1";
      });
    }
  }, []);

  const [funding, setFunding] = useState(
    parsedData === null ? undefined : parsedData.funding
  );

  const [offer, setOffer] = useState(
    parsedData === null ? undefined : parsedData.offer
  );

  const [service, setService] = useState(
    parsedData === null ? undefined : parsedData.service
  );

  const [bookingId, setBooking] = useState(
    parsedData === null ? undefined : parsedData.bookingId
  );

  const changeFunding = (newValue) => {
    setFunding(newValue);
  };

  const changeOffer = (index, id) => {
    let box = document.getElementById(`offer_${index}`);
    let picture = document.getElementById(`offer_picture_${index}`);

    if (offer === id) {
      box.className = "offer-text-1";
      itemsDataOffer.forEach((item, index2) => {
        document.getElementById(`offer_picture_${index2}`).className =
          "offer-1";
        document.getElementById(`offer_${index2}`).className = "offer-text-1";
      });
      setOffer();
      changeBooking();
    } else {
      itemsDataOffer.forEach((item, index2) => {
        document.getElementById(`offer_picture_${index2}`).className =
          "offer-1-gray";
        document.getElementById(`offer_${index2}`).className = "offer-text-1";
      });

      box.className = "offer-text-1-selected";
      picture.className = "offer-1";
      setOffer(id);
    }
  };

  const changeService = (newValue) => {
    setService(newValue);
  };

  const changeBooking = (id) => {
    setBooking(id);
  };

  function goNext() {
    const dataToPass = {
      funding: funding,
      offer: offer,
      bookingId: bookingId,
      service: service,
    };

    sessionStorage.setItem("storeData", JSON.stringify(dataToPass));

    setIsSubmittingButton(true);
    navigate(`/${RoutePathConstants.StoreSummary}`);
  }

  return (
    <>
      <Card>
        <Card.Body className="pt-4-5 store-card-body background_1">
          {isSubmitting ? (
            <Loading size="lg" className="px-30" variant="dark" />
          ) : (
            <div>
              <div className="text-box1">
                <div className="text-1">
                  Wybierz z jakich usług chcesz skorzystać
                </div>
              </div>

              {itemsDataFunding &&
                itemsDataFunding.map((object, index) => (
                  <>
                    <div className="button-box">
                      <div className="pt-4-5 background_2">
                        <div className="divRow">
                          <div className="background-left-main">
                            <WindowText
                              title={object.name === null ? null : object.name}
                              description={
                                object.description === null
                                  ? null
                                  : object.description
                              }
                              class={"description-1"}
                            />
                          </div>
                          <div className="background-right-main">
                            <div
                              className="picture"
                              style={{
                                padding: "10vh",
                                backgroundImage: `url(${object.image})`,
                              }}
                              title={object.photo_name}
                            ></div>
                          </div>
                        </div>
                        <Row>
                          <button
                            className="button-confirm-1"
                            onClick={() => {
                              funding === object.id
                                ? changeFunding(null)
                                : changeFunding(object.id);
                            }}
                          >
                            {object.id === funding ? (
                              <span className="accept-cancel-button-active">
                                <span className="accept-cancel-button-text">
                                  Kliknij, aby anulować
                                </span>
                                <FontAwesomeIcon
                                  icon={faCircleLeft}
                                  className="accept-cancel-button-icon"
                                />
                              </span>
                            ) : (
                              <span className="accept-cancel-button">
                                <FontAwesomeIcon
                                  icon={faCircleRight}
                                  className="accept-cancel-button-icon"
                                />
                                <span className="accept-cancel-button-text">
                                  Kliknij, aby wybrać
                                </span>
                              </span>
                            )}
                          </button>
                        </Row>
                      </div>
                    </div>
                  </>
                ))}

              <WindowOffers
                offer={offer}
                changeOffer={changeOffer}
                changeBooking={changeBooking}
                itemsData={itemsDataOffer}
              />

              {itemsDataService &&
                itemsDataService.map((object, index) => (
                  <WindowService
                    name={object.name === null ? null : object.name}
                    text={
                      object.description === null ? null : object.description
                    }
                    textButton={"Wybieram"}
                    type={service}
                    id={object.id}
                    changeMethod={changeService}
                    image={object.image}
                    photo_name={object.photo_name}
                  />
                ))}

              <div className="button-box margin-button">
                <button
                  className="confirm-store-button button-check button-100"
                  disabled={isSubmittingButton}
                  onClick={goNext}
                >
                  {isSubmittingButton ? (
                    <Loading size="lg" className="px-10" variant="light" />
                  ) : (
                    <>Zatwierdzam wybór</>
                  )}
                </button>
              </div>
            </div>
          )}
        </Card.Body>
      </Card>
    </>
  );
}

export default Store;
